import React from "react";

function ReadOnlyField({ label, value }) {
  return (
    <div className="mb-2">
      <label className="form-label small text-muted mb-1">{label}</label>
      <input type="text" className="form-control" value={value || ""} readOnly />
    </div>
  );
}

function onlyDigits(value) {
  return String(value || "").replace(/\D/g, "");
}

function formatCpfCnpj(value) {
  const digits = onlyDigits(value);

  if (digits.length === 11) {
    return digits.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
  }

  if (digits.length === 14) {
    return digits.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
  }

  return value || "";
}

function formatPhone(value) {
  const digits = onlyDigits(value);

  if (digits.length === 11) {
    return digits.replace(/(\d{2})(\d{5})(\d{4})/, "($1) $2-$3");
  }

  if (digits.length === 10) {
    return digits.replace(/(\d{2})(\d{4})(\d{4})/, "($1) $2-$3");
  }

  return value || "";
}

export default function ClientInfo({ client }) {
  if (!client) return null;

  const hasAddressLine1 = Boolean(client.addressLine1?.trim());
  const hasAddressLine2 = Boolean(client.addressLine2?.trim());
  const hasPhone2 = Boolean(client.phone2?.trim());

  return (
    <div className="card mb-3">
      <div className="card-header d-flex justify-content-between align-items-center">
        <strong>Dados do Cliente</strong>
        <span className="badge bg-info text-dark">Pessoa Juridica</span>
      </div>

      <div className="card-body">
        <div className="row g-4">
          <div className="col-lg-8">
            <div className="row g-2">
              <div className="col-12">
                <ReadOnlyField label="Cliente" value={client.name} />
              </div>
              <div className="col-12">
                <ReadOnlyField label="Nome fantasia" value={client.fantasyName} />
              </div>
              <div className="col-md-4 col-sm-6">
                <ReadOnlyField label="CPF/CNPJ" value={formatCpfCnpj(client.cpfCnpj)} />
              </div>
              <div className="col-md-4 col-sm-6">
                <ReadOnlyField label="Telefone" value={formatPhone(client.phone)} />
              </div>
              <div className="col-md-4 col-sm-6">
                <ReadOnlyField label="Email" value={client.email} />
              </div>
              {hasPhone2 ? (
                <div className="col-md-4 col-sm-6">
                  <ReadOnlyField label="Telefone 2" value={formatPhone(client.phone2)} />
                </div>
              ) : null}
              {hasAddressLine1 ? (
                <div className="col-12">
                  <ReadOnlyField label="Endereco 1" value={client.addressLine1} />
                </div>
              ) : null}
              {hasAddressLine2 ? (
                <div className="col-12">
                  <ReadOnlyField label="Endereco 2" value={client.addressLine2} />
                </div>
              ) : null}
            </div>
          </div>

          <div className="col-lg-4">
            <div className="card h-100">
              <div className="card-body">
                <h6 className="fw-bold">Observacao do Cliente</h6>
                <p className="text-muted mb-3">{client.customerObservation || "Sem observacoes."}</p>

                <h6 className="fw-bold">Observacao do Veiculo/Contrato</h6>
                <p className="text-muted mb-0">{client.vehicleContractObservation || "Sem observacoes."}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
